/* AnchorFit theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  function formatMoney(cents) {
    var fmt = theme.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var withDelims = function (num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(n, 2, "'", '.');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ */
  /* Drawers (menu + cart)                                               */
  /* ------------------------------------------------------------------ */

  var Drawers = {
    current: null,
    lastFocus: null,
    overlay: null,

    init: function () {
      this.overlay = qs('[data-overlay]');
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-drawer-open]');
        if (opener) {
          var id = opener.getAttribute('data-drawer-open');
          var drawer = document.getElementById(id);
          if (drawer) {
            e.preventDefault();
            self.open(drawer, opener);
          }
          return;
        }
        if (e.target.closest('[data-drawer-close]') || e.target === self.overlay) {
          self.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.current) self.close();
      });
    },

    open: function (drawer, opener) {
      if (this.current && this.current !== drawer) this.close(true);
      this.current = drawer;
      this.lastFocus = opener || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-open-drawer');
      if (this.overlay) {
        this.overlay.hidden = false;
        requestAnimationFrame(function () { Drawers.overlay.classList.add('is-visible'); });
      }
      qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var focusTarget = qs('[data-drawer-close]', drawer);
      if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 50);
    },

    close: function (instant) {
      var drawer = this.current;
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-open-drawer');
      qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (this.overlay) {
        this.overlay.classList.remove('is-visible');
        var ov = this.overlay;
        setTimeout(function () { if (!Drawers.current) ov.hidden = true; }, instant ? 0 : 250);
      }
      this.current = null;
      if (this.lastFocus && !instant) this.lastFocus.focus({ preventScroll: true });
    }
  };

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */

  var Cart = {
    sectionId: 'cart-drawer',

    drawer: function () { return document.getElementById('CartDrawer'); },

    isDrawer: function () { return theme.cartType === 'drawer' && !!this.drawer(); },

    optOutKey: 'af_addons_off',

    optedOut: function () {
      try { return JSON.parse(sessionStorage.getItem(this.optOutKey) || '[]'); } catch (e) { return []; }
    },

    setOptOut: function (id, off) {
      var list = this.optedOut().filter(function (x) { return x !== id; });
      if (off) list.push(id);
      try { sessionStorage.setItem(this.optOutKey, JSON.stringify(list)); } catch (e) {}
    },

    addonState: function () {
      var el = qs('#CartDrawer [data-cart-addons]');
      if (!el) return { main: 0, addons: [] };
      try { return JSON.parse(el.textContent); } catch (e) { return { main: 0, addons: [] }; }
    },

    // Pre-selected add-ons that should ride along with a product add
    autoAddons: function () {
      var off = this.optedOut();
      return this.addonState().addons.filter(function (a) {
        return a.pre && !a.inCart && off.indexOf(a.id) === -1;
      }).map(function (a) { return { id: a.id, quantity: 1 }; });
    },

    // If only add-ons are left in the cart, remove them too
    cleanupOrphans: function () {
      var state = this.addonState();
      if (state.main > 0) return;
      var updates = {};
      var any = false;
      state.addons.forEach(function (a) { if (a.inCart && a.key) { updates[a.key] = 0; any = true; } });
      if (!any) return;
      var self = this;
      this.request(theme.routes.cart + '/update.js', { updates: updates, sections: [this.sectionId], sections_url: window.location.pathname })
        .then(function (data) { self.render(data.sections && data.sections[self.sectionId], true); });
    },

    init: function () {
      var self = this;

      var initialCount = qs('#CartDrawer [data-cart-count-value]');
      if (initialCount) this.updateCount(parseInt(initialCount.getAttribute('data-cart-count-value'), 10));

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-cart-open]');
        if (openBtn && self.isDrawer()) {
          e.preventDefault();
          Drawers.open(self.drawer(), openBtn);
          return;
        }

        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn && qtyBtn.closest('#CartDrawer')) {
          e.preventDefault();
          var line = qtyBtn.closest('[data-line]');
          var input = qs('[data-qty-input]', line);
          var next = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
          self.change(line.getAttribute('data-key'), next);
          return;
        }

        var removeBtn = e.target.closest('[data-line-remove]');
        if (removeBtn && removeBtn.closest('#CartDrawer')) {
          e.preventDefault();
          self.change(removeBtn.closest('[data-line]').getAttribute('data-key'), 0);
        }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('#CartDrawer [data-qty-input]');
        if (input) {
          var line = input.closest('[data-line]');
          self.change(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
          return;
        }
        var addon = e.target.closest('#CartDrawer [data-addon-toggle]');
        if (addon) {
          self.setOptOut(parseInt(addon.value, 10), !addon.checked);
          if (addon.checked) {
            self.addItems([{ id: parseInt(addon.value, 10), quantity: 1 }]);
          } else if (addon.getAttribute('data-line-key')) {
            self.change(addon.getAttribute('data-line-key'), 0);
          }
        }
      });
    },

    setBusy: function (busy) {
      var d = this.drawer();
      if (d) d.classList.toggle('is-busy', busy);
    },

    render: function (html, skipCleanup) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-cart-drawer-inner]', doc);
      var current = qs('#CartDrawer [data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
      var countEl = qs('[data-cart-count-value]', doc);
      if (countEl) this.updateCount(parseInt(countEl.getAttribute('data-cart-count-value'), 10));
      if (!skipCleanup) this.cleanupOrphans();
    },

    updateCount: function (count) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },

    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          return data;
        });
      });
    },

    addForm: function (form, extras) {
      var fd = new FormData(form);
      var body = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
      fd.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m) { body.items[0].properties = body.items[0].properties || {}; body.items[0].properties[m[1]] = value; }
      });
      if (fd.get('selling_plan')) body.items[0].selling_plan = fd.get('selling_plan');
      return this.addItems(body.items.concat(extras || [], this.autoAddons()), true);
    },

    addItems: function (items, openAfter) {
      var self = this;
      if (!this.isDrawer()) {
        return this.request(theme.routes.cartAdd + '.js', { items: items }).then(function () {
          window.location.href = theme.routes.cart;
        });
      }
      this.setBusy(true);
      return this.request(theme.routes.cartAdd + '.js', { items: items, sections: [this.sectionId], sections_url: window.location.pathname })
        .then(function (data) {
          self.render(data.sections && data.sections[self.sectionId]);
          if (openAfter) Drawers.open(self.drawer());
        })
        .finally(function () { self.setBusy(false); });
    },

    change: function (key, quantity) {
      var self = this;
      this.setBusy(true);
      return this.request(theme.routes.cartChange + '.js', { id: key, quantity: quantity, sections: [this.sectionId], sections_url: window.location.pathname })
        .then(function (data) {
          self.render(data.sections && data.sections[self.sectionId]);
        })
        .catch(function (err) { window.alert(err.message); self.refresh(); })
        .finally(function () { self.setBusy(false); });
    },

    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=' + this.sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) { self.render(data[self.sectionId]); });
    }
  };

  /* ------------------------------------------------------------------ */
  /* Product (gallery, offer cards, form, sticky bar)                    */
  /* ------------------------------------------------------------------ */

  function Gallery(el) {
    this.el = el;
    this.track = qs('[data-gallery-track]', el);
    this.slides = qsa('[data-gallery-slide]', el);
    this.thumbs = qsa('[data-thumb]', el);
    this.prev = qs('[data-gallery-prev]', el);
    this.next = qs('[data-gallery-next]', el);
    this.counter = qs('[data-gallery-counter]', el);
    this.index = 0;
    if (!this.track || this.slides.length === 0) return;

    var self = this;
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1); });

    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        if (i !== self.index) self.setActive(i);
      });
    }, { passive: true });

    this.setActive(0);
  }

  Gallery.prototype.goTo = function (i, instant) {
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.track.scrollTo({ left: this.track.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
    this.setActive(i);
  };

  Gallery.prototype.goToMedia = function (mediaId, instant) {
    if (!mediaId) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.goTo(i, instant); return; }
    }
  };

  Gallery.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (t, n) {
      t.classList.toggle('is-active', n === i);
      if (n === i && t.parentElement) {
        var p = t.parentElement;
        var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    });
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i === this.slides.length - 1;
    if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
    this.slides.forEach(function (s, n) {
      if (n !== i) qsa('video', s).forEach(function (v) { v.pause(); });
    });
  };

  function Product(el) {
    this.el = el;
    var json = qs('[data-product-json]', el);
    this.data = json ? JSON.parse(json.textContent) : { variants: [] };
    this.form = qs('[data-product-form]', el);
    this.galleryEl = qs('[data-gallery]', el);
    this.gallery = this.galleryEl ? new Gallery(this.galleryEl) : null;
    this.sticky = qs('[data-sticky-atc]', el);

    var self = this;

    el.addEventListener('change', function (e) {
      if (e.target.matches('[data-variant-radio]')) self.select(parseInt(e.target.value, 10));
      if (e.target.matches('[data-option-index]')) self.selectFromOptions();
      if (e.target.matches('[data-break-qty]')) self.selectBreak(e.target);
    });

    el.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var input = qs('[data-product-qty]', el);
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.submit();
      });
    }

    var initial = this.currentVariant();
    if (initial && this.gallery && el.hasAttribute('data-variant-media-first')) {
      this.gallery.goToMedia(initial.media, true);
    }
    if (initial) this.updateStock(initial);

    this.initSticky();
    this.initDelivery();
  }

  Product.prototype.currentVariant = function () {
    var checked = qs('[data-variant-radio]:checked', this.el);
    var hidden = this.form ? qs('input[name="id"]', this.form) : null;
    var id = checked ? parseInt(checked.value, 10) : hidden ? parseInt(hidden.value, 10) : null;
    return this.find(id);
  };

  Product.prototype.find = function (id) {
    for (var i = 0; i < this.data.variants.length; i++) {
      if (this.data.variants[i].id === id) return this.data.variants[i];
    }
    return null;
  };

  Product.prototype.selectBreak = function (input) {
    qsa('[data-break-card]', this.el).forEach(function (c) { c.classList.toggle('is-selected', c.contains(input)); });
    var q = qs('[data-product-qty]', this.el);
    if (q) q.value = input.getAttribute('data-break-qty');
  };

  Product.prototype.updateBreaks = function (v) {
    qsa('[data-break-qty]', this.el).forEach(function (input) {
      var card = input.closest('[data-break-card]');
      var q = parseInt(input.getAttribute('data-break-qty'), 10);
      var pct = parseInt(input.getAttribute('data-break-pct') || '0', 10);
      var total = Math.floor(v.price_cents * q * (100 - pct) / 100);
      var unitCompare = Math.max(v.compare_cents || 0, v.price_cents);
      var compareTotal = unitCompare * q;
      var price = qs('[data-break-price]', card);
      var compare = qs('[data-break-compare]', card);
      var caption = qs('[data-break-caption]', card);
      if (price) price.textContent = formatMoney(total);
      if (compare) { compare.textContent = formatMoney(compareTotal); compare.hidden = compareTotal <= total; }
      if (caption) { caption.textContent = caption.getAttribute('data-template').replace('[amount]', formatMoney(compareTotal - total)); caption.hidden = compareTotal <= total; }
    });
  };

  Product.prototype.selectFromOptions = function () {
    var picker = qs('[data-option-picker]', this.el);
    if (!picker) return;
    var chosen = [];
    qsa('[data-option-index]:checked', picker).forEach(function (r) {
      chosen[parseInt(r.getAttribute('data-option-index'), 10)] = r.value;
      var label = qs('[data-option-value="' + r.getAttribute('data-option-index') + '"]', picker);
      if (label) label.textContent = r.value;
    });
    var match = null;
    this.data.variants.forEach(function (v) {
      if (!match && v.options.every(function (o, i) { return o === chosen[i]; })) match = v;
    });
    var hidden = this.form ? qs('input[name="id"]', this.form) : null;
    if (!match) {
      qsa('[data-add-button]', this.el).forEach(function (b) {
        b.disabled = true;
        var l = qs('[data-add-label]', b);
        if (l) l.textContent = 'Unavailable';
      });
      return;
    }
    if (hidden) hidden.value = match.id;
    this.select(match.id);
  };

  Product.prototype.select = function (id) {
    var v = this.find(id);
    if (!v) return;
    var el = this.el;

    qsa('[data-variant-radio]', el).forEach(function (r) {
      r.closest('.offer-card').classList.toggle('is-selected', parseInt(r.value, 10) === id);
    });

    qsa('[data-price]', el).forEach(function (n) { n.textContent = v.price; });
    qsa('[data-compare]', el).forEach(function (n) { n.textContent = v.compare || ''; n.hidden = !v.compare; });
    qsa('[data-save]', el).forEach(function (n) {
      var tpl = n.getAttribute('data-save-template') || 'Save [percent]%';
      n.textContent = tpl.replace('[percent]', v.save).replace('[amount]', v.save_amount || '');
      n.hidden = !v.compare;
    });

    qsa('[data-add-button]', el).forEach(function (b) {
      b.disabled = !v.available;
      var label = qs('[data-add-label]', b);
      if (label) label.textContent = v.available ? (b.getAttribute('data-label') || theme.strings.addToCart) : theme.strings.soldOut;
    });

    this.updateStock(v);
    this.updateBreaks(v);

    if (this.gallery && v.media) this.gallery.goToMedia(v.media);

    if (el.hasAttribute('data-update-url') && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  Product.prototype.updateStock = function (v) {
    qsa('[data-stock]', this.el).forEach(function (s) {
      var threshold = parseInt(s.getAttribute('data-threshold') || '0', 10);
      var label = qs('[data-stock-label]', s);
      if (!v.available) { s.hidden = true; return; }
      if (v.tracked && v.qty > 0 && v.qty <= threshold) {
        s.hidden = false;
        s.classList.add('stock--low');
        label.textContent = (theme.strings.lowStock || 'Low stock: [qty] left').replace('[qty]', v.qty);
      } else if (theme.strings.inStock) {
        s.hidden = false;
        s.classList.remove('stock--low');
        label.textContent = theme.strings.inStock;
      } else {
        s.hidden = true;
      }
    });
  };

  Product.prototype.submit = function () {
    var self = this;
    var missing = null;
    qsa('input[data-required-message]', this.el).forEach(function (i) { if (!missing && !i.value.trim()) missing = i; });
    if (missing) {
      var errBox = qs('[data-form-error]', this.el);
      if (errBox) { errBox.textContent = missing.getAttribute('data-required-message'); errBox.hidden = false; }
      missing.focus();
      missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var buttons = qsa('[data-add-button], [data-sticky-btn]', this.el);
    var error = qs('[data-form-error]', this.el);
    if (error) error.hidden = true;
    buttons.forEach(function (b) { b.classList.add('is-loading'); });

    var extras = qsa('[data-upsell-toggle]:checked', this.el).map(function (t) { return { id: parseInt(t.value, 10), quantity: 1 }; });
    Cart.addForm(this.form, extras)
      .catch(function (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      })
      .finally(function () {
        buttons.forEach(function (b) { b.classList.remove('is-loading'); });
      });
  };

  Product.prototype.initSticky = function () {
    var sticky = this.sticky;
    var target = qs('[data-add-button]', this.el);
    if (!sticky || !target || !('IntersectionObserver' in window)) return;
    var footer = qs('.site-footer');
    var mainVisible = true;
    var footerVisible = false;
    var update = function () { sticky.classList.toggle('is-visible', !mainVisible && !footerVisible && target.getBoundingClientRect().top < 0); };

    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(target);

    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }

    var btn = qs('[data-sticky-btn]', sticky);
    var self = this;
    if (btn && btn.getAttribute('data-sticky-mode') === 'scroll') {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = qs('.offer-picker', self.el) || target;
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  };

  Product.prototype.initDelivery = function () {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var fmt = function (d) { return months[d.getMonth()] + ' ' + d.getDate(); };
    var add = function (days, skipWeekends) {
      var d = new Date();
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (!skipWeekends || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
      }
      return d;
    };
    qsa('[data-delivery-date]', this.el).forEach(function (n) {
      var min = parseInt(n.getAttribute('data-min') || '0', 10);
      var max = parseInt(n.getAttribute('data-max') || '0', 10);
      var skip = n.hasAttribute('data-skip-weekends');
      var a = fmt(add(min, skip));
      var b = fmt(add(max, skip));
      n.textContent = a === b ? a : a + ' – ' + b;
    });
  };

  /* ------------------------------------------------------------------ */
  /* Announcement rotator + countdown                                    */
  /* ------------------------------------------------------------------ */

  function initRotators() {
    qsa('[data-rotator]').forEach(function (rot) {
      var items = qsa('.announcement__item', rot);
      if (items.length < 2) return;
      var i = 0;
      var speed = parseInt(rot.getAttribute('data-speed') || '4', 10) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  function initCountdowns() {
    qsa('[data-countdown]').forEach(function (el) {
      var raw = el.getAttribute('data-countdown');
      var end = new Date(raw.replace(' ', 'T'));
      if (isNaN(end.getTime())) return;
      var wrap = el.closest('[data-countdown-wrap]') || el;
      var parts = {
        d: qs('[data-cd="d"]', el), h: qs('[data-cd="h"]', el),
        m: qs('[data-cd="m"]', el), s: qs('[data-cd="s"]', el)
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var diff = Math.floor((end.getTime() - Date.now()) / 1000);
        if (diff <= 0) { wrap.hidden = true; clearInterval(timer); return; }
        wrap.hidden = false;
        parts.d.textContent = pad(Math.floor(diff / 86400));
        parts.h.textContent = pad(Math.floor((diff % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((diff % 3600) / 60));
        parts.s.textContent = pad(diff % 60);
      };
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Header height (for sticky gallery offset)                           */
  /* ------------------------------------------------------------------ */

  function setHeaderHeight() {
    var h = qs('.site-header-wrap');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------ */
  /* Quick add, tabs, show more, collection filters                      */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      var items = [{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }];
      if (Cart.addonState().main === 0) items = items.concat(Cart.autoAddons());
      Cart.addItems(items, true)
        .catch(function (err) { window.alert(err.message); })
        .finally(function () { quick.classList.remove('is-loading'); });
      return;
    }

    var tab = e.target.closest('[data-tab]');
    if (tab) {
      var group = tab.closest('[data-tabs]');
      qsa('[data-tab]', group).forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      qsa('[data-tab-panel]', group).forEach(function (p) {
        p.hidden = p.getAttribute('data-tab-panel') !== tab.getAttribute('data-tab');
      });
      return;
    }

    var more = e.target.closest('[data-show-more]');
    if (more) {
      var target = document.getElementById(more.getAttribute('data-show-more'));
      if (target) target.classList.add('is-expanded');
      more.closest('.show-more').hidden = true;
    }
  });

  document.addEventListener('change', function (e) {
    var filterInput = e.target.closest('[data-filter-form] input[type="checkbox"]');
    if (filterInput) filterInput.form.submit();
    var sort = e.target.closest('[data-sort]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  function initProducts(root) {
    qsa('[data-product]', root).forEach(function (el) {
      if (el.__product) return;
      el.__product = new Product(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Drawers.init();
    Cart.init();
    initProducts(document);
    initRotators();
    initCountdowns();
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initProducts(e.target);
    initCountdowns();
    setHeaderHeight();
  });

  window.AnchorFit = { Cart: Cart, Drawers: Drawers };
})();
